import {
  isSAdmin,
  isSender,
  isSubAdmin,
} from "app/main/helpers/userData.helper";
import { environment } from "./../environments/environment";
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ElementRef,
  Renderer2,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Title } from "@angular/platform-browser";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import * as Waves from "node-waves";

import { CoreMenuService } from "@core/components/core-menu/core-menu.service";
import { CoreSidebarService } from "@core/components/core-sidebar/core-sidebar.service";
import { CoreConfigService } from "@core/services/config.service";
import { CoreLoadingScreenService } from "@core/services/loading-screen.service";
import { CoreTranslationService } from "@core/services/translation.service";
import { CustomerService } from "app/main/services/customer.service";
import { ThemeConfigService } from "app/main/services/theme-config.service"; //

import { locale as menuEnglish } from "app/menu/i18n/en";
import { locale as menuFrench } from "app/menu/i18n/fr";
import { locale as menuGerman } from "app/menu/i18n/de";
import { locale as menuPortuguese } from "app/menu/i18n/pt";
import { PermissionService } from "./main/services/permission.service";
import { AuthenticationService, UserService } from "./auth/service";
import { SocketIoService } from "./main/services/io.service";
import { ToastrService } from "ngx-toastr";
import { DeviceDetectorService } from "ngx-device-detector";
import { UploadService } from "app/main/services/upload.service";
import flatpickr from "flatpickr";
import FlatpickrI18n from "flatpickr/dist/l10n/es";
import { validateBrowser } from "./main/helpers/globalConfig";
import { AlertsService } from "./main/services/alerts.service";
import { convertToUUID } from "app/main/helpers/binaryData";
import { HttpClient } from "@angular/common/http";
import { Location } from "@angular/common";
import {
  filterMenuModulesByRole,
  filterMenuModulesByRoleAndAcl,
} from "./main/helpers/menu.helper";
// import { WEBSOCKET_EVENT } from "./main/shared/enums/WebsocketEvent.enum";
import { Router } from "@angular/router";
import { CoreMenu } from "@core/types";
import { PlanService } from "app/main/services/plan.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  coreConfig: any;
  menu: CoreMenu[] = [];
  defaultLanguage: "fr"; // This language will be used as a fallback when a translation isn't found in the current language
  appLanguage: "fr"; // Set application default language i.e fr

  public primary: string;
  public secondary: string;
  public hoverprimary: string;
  public hoversecondary: string;
  public info: string;
  public warning: string;
  public light: string;
  public dark: string;
  public custom: string;
  public inputDarkMode: string;
  public colorDarkMode: string;
  public success: string;
  public convertToUUID = convertToUUID;
  company: any;
  user: any;
  logo: any;
  logo2: any;

  ipAddress = "";

  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _title: Title,
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    public _coreConfigService: CoreConfigService,
    private _coreSidebarService: CoreSidebarService,
    private _coreLoadingScreenService: CoreLoadingScreenService, // ! No borrar
    private _coreMenuService: CoreMenuService,
    private _coreTranslationService: CoreTranslationService,
    private _translateService: TranslateService,
    private _permissionService: PermissionService,
    private _auth: AuthenticationService,
    private _customerService: CustomerService,
    private _themeConfig: ThemeConfigService,
    private _device: DeviceDetectorService,
    private _socketIOService: SocketIoService,
    private readonly planService: PlanService,
    private _alerts: AlertsService,
    private router: Router,
    private _toastr: ToastrService
  ) {
    console.log("¡¡INIT APP CONSTRUCTOR!!");
    this.router.events.subscribe((val: any) => {
      const currentUrl = window.location.hash;
      if (currentUrl === "#/campaing-builder") {
        this._elementRef.nativeElement.classList.add(
          "navbar-hidden",
          "navbar-none"
        );
        this._elementRef.nativeElement.classList.remove("navbar-b");
      } else {
        this._elementRef.nativeElement.classList.remove(
          "navbar-hidden",
          "navbar-none"
        );
        this._elementRef.nativeElement.classList.add("navbar-b");
      }
    });

    this.verifyBrowser();
    this.userChangeEvent();
    this._translateService.addLangs(["en", "fr", "de", "pt"]);
    this._translateService.setDefaultLang("fr");
    this._coreTranslationService.translate(
      menuEnglish,
      menuFrench,
      menuGerman,
      menuPortuguese
    );

    // Set the private default
    this._unsubscribeAll = new Subject();

    flatpickr.localize(FlatpickrI18n.es);

    const tableEmpyMsg = document.getElementsByClassName("empty-row");
    tableEmpyMsg.innerHTML = "Sin registros para mostrar";

    const urlParams = new URLSearchParams(window.location.search);
    const saml2Token = urlParams.get("token");
    if (saml2Token) {
      setTimeout(() => {
        this._auth.refreshToken(saml2Token).subscribe((res) => {
          this.router.navigate(["/"]);
          const user = res.user;

          setTimeout(() => {
            this._toastr.success(
              `👋 Bienvenido de nuevo ${user?.first_name} ${user?.last_name}.`,
              "Autenticado",
              {
                toastClass: "toast ngx-toastr",
                closeButton: true,
              }
            );
          }, 2000);
        });
      }, 1000);
    }
  }

  ngOnInit(): void {
    this.initApp();
    console.log("\n\nAPP INITIALIZE: ", environment);
  }

  filterMenuModules = async () => {
    const role = this._auth.role;
    if (!role) return;
    console.log("USER", this._auth.user);
    let menu = isSAdmin(role)
      ? filterMenuModulesByRole(role)
      : filterMenuModulesByRoleAndAcl(
          role,
          this._auth.permission?.modules ?? {}
        );

    if (isSender(role) || isSubAdmin(role)) {
      console.info("To filter product menu: ");
      const plan = await this.planService.getMyPlan().toPromise();
      const sendTypes = plan.provisionings.map((p) => p.product.send_type);
      const enabled = plan.provisionings.reduce((a, p) => {
        a[p.product.send_type] = p.enabled;
        return a;
      }, {});
      console.info("SENT TYPES AVAILABLE: ", sendTypes);
      menu = menu.filter((m) =>
        ["sms", "whatsapp", "email"].includes(m.module)
          ? sendTypes.includes(m.module) && enabled[m.module]
          : true
      );
    }

    menu.map((item) => {
      if (item.id === "reports" && item.children) {
        item.children = item.children.filter((child) => {
          if (child.id === "emg" || child.id === "emg-received") {
            return this._auth.user.emgSend;
          }
          return true;
        });
      }
      return item;
    });

    this.menu = menu;
    this._coreMenuService.unregister("main");
    this._coreMenuService.register("main", this.menu);
    this._coreMenuService.setCurrentMenu("main");
  };

  verifyBrowser(): void {
    const version = Number(this._device.browser_version.split(".")[0]);
    const browser = this._device.browser;

    if (validateBrowser(browser, version)) return;

    this._alerts.showOldBrowserAlert();
  }

  initApp = () => {
    // Init wave effect (Ripple effect)
    Waves.init();

    // Subscribe to config changes
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.coreConfig = config;

        // Set application default language.

        // Change application language? Read the ngxTranslate Fix

        // ? Use app-config.ts file to set default language
        const appLanguage = this.coreConfig.app.appLanguage || "fr";
        this._translateService.use(appLanguage);

        // ? OR
        // ? User the current browser lang if available, if undefined use 'en'
        // const browserLang = this._translateService.getBrowserLang();
        // this._translateService.use(browserLang.match(/en|fr|de|pt/) ? browserLang : 'en');

        /**
         * ! Fix : ngxTranslate
         * ----------------------------------------------------------------------------------------------------
         */

        /**
         *
         * Using different language than the default ('en') one i.e French?
         * In this case, you may find the issue where application is not properly translated when your app is initialized.
         *
         * It's due to ngxTranslate module and below is a fix for that.
         * Eventually we will move to the multi language implementation over to the Angular's core language service.
         *
         **/

        // Set the default language to 'en' and then back to 'fr'.

        setTimeout(() => {
          this._translateService.setDefaultLang("fr");
          this._translateService.setDefaultLang(appLanguage);
        });

        /**
         * !Fix: ngxTranslate
         * ----------------------------------------------------------------------------------------------------
         */

        // Layout
        //--------

        // Remove default classes first
        this._elementRef.nativeElement.classList.remove(
          "vertical-layout",
          "vertical-menu-modern",
          "horizontal-layout",
          "horizontal-menu"
        );
        // Add class based on config options
        if (this.coreConfig.layout?.type === "vertical") {
          this._elementRef.nativeElement.classList.add(
            "vertical-layout",
            "vertical-menu-modern"
          );
        } else if (this.coreConfig.layout?.type === "horizontal") {
          this._elementRef.nativeElement.classList.add(
            "horizontal-layout",
            "horizontal-menu"
          );
        }

        // Navbar
        //--------

        // Remove default classes first
        this._elementRef.nativeElement.classList.remove(
          "navbar-floating",
          "navbar-static",
          "navbar-sticky",
          "navbar-hidden"
        );

        // Add class based on config options
        if (this.coreConfig.layout.navbar.type === "navbar-static-top") {
          this._elementRef.nativeElement.classList.add("navbar-static");
        } else if (this.coreConfig.layout.navbar.type === "fixed-top") {
          this._elementRef.nativeElement.classList.add("navbar-sticky");
        } else if (this.coreConfig.layout.navbar.type === "floating-nav") {
          this._elementRef.nativeElement.classList.add("navbar-floating");
        } else {
          this._elementRef.nativeElement.classList.add("navbar-hidden");
        }

        // Footer
        //--------

        // Remove default classes first
        this._elementRef.nativeElement.classList.remove(
          "footer-fixed",
          "footer-static",
          "footer-hidden"
        );

        // Add class based on config options
        if (this.coreConfig.layout.footer.type === "footer-sticky") {
          this._elementRef.nativeElement.classList.add("footer-fixed");
        } else if (this.coreConfig.layout.footer.type === "footer-static") {
          this._elementRef.nativeElement.classList.add("footer-static");
        } else {
          this._elementRef.nativeElement.classList.add("footer-hidden");
        }

        // Blank layout
        if (
          this.coreConfig.layout.menu.hidden &&
          this.coreConfig.layout.navbar.hidden &&
          this.coreConfig.layout.footer.hidden
        ) {
          this._elementRef.nativeElement.classList.add("blank-page");
          // ! Fix: Transition issue while coming from blank page
          this._renderer.setAttribute(
            this._elementRef.nativeElement.getElementsByClassName(
              "app-content"
            )[0],
            "style",
            "transition:none"
          );
        } else {
          this._elementRef.nativeElement.classList.remove("blank-page");
          // ! Fix: Transition issue while coming from blank page
          setTimeout(() => {
            this._renderer.setAttribute(
              this._elementRef.nativeElement.getElementsByClassName(
                "app-content"
              )[0],
              "style",
              "transition:300ms ease all"
            );
          }, 0);
          // If navbar hidden
          if (this.coreConfig.layout.navbar.hidden) {
            this._elementRef.nativeElement.classList.add("navbar-hidden");
          }
          // Menu (Vertical menu hidden)
          if (this.coreConfig.layout.menu.hidden) {
            this._renderer.setAttribute(
              this._elementRef.nativeElement,
              "data-col",
              "1-column"
            );
          } else {
            this._renderer.removeAttribute(
              this._elementRef.nativeElement,
              "data-col"
            );
          }
          // Footer
          if (this.coreConfig.layout.footer.hidden) {
            this._elementRef.nativeElement.classList.add("footer-hidden");
          }
        }

        // Skin Class (Adding to body as it requires highest priority)
        if (
          this.coreConfig.layout.skin !== "" &&
          this.coreConfig.layout.skin !== undefined
        ) {
          this.document.body.classList.remove(
            "default-layout",
            "bordered-layout",
            "dark-layout",
            "semi-dark-layout"
          );
          this.document.body.classList.add(
            this.coreConfig.layout.skin + "-layout"
          );
        }
      });

    // Set the application page title
    this._title.setTitle(this.coreConfig.app.appTitle);
  };

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  getLoadingImage(themeId) {
    this._themeConfig.getById(themeId).subscribe((res) => {
      const loadingLogo = res?.loading_logo; // * Error en consola, controlado con ?
      const root: any = document.querySelector(":root");
      const logo = ` url('${loadingLogo}')`;
      root.style.setProperty("--loading-logo", logo);
    });
  }

  getImage(themeId) {
    this._themeConfig.getById(themeId).subscribe((res) => {
      this.setLogo(res?.logo); // * Error en consola, controlado con ?
    });
  }

  setLogo(logo) {
    this.logo = logo;
    this._coreConfigService.setConfig(
      { app: { appLogoImage: logo } },
      { emitEvent: true }
    );
  }

  userChangeEvent = () => {
    this._auth.currentUser.subscribe((user) => {
      if (!user) {
        this._socketIOService.disconnect();
        return;
      }
      if (user.owner_id) {
        this._customerService
          .getCompanyById(user.owner_id)
          .subscribe((model) => {
            this._themeConfig.setThemeConfig(model.theme_config_id);
            this.getLoadingImage(model.theme_config_id);
            this.getImage(model.theme_config_id);
          });
      }
      this._permissionService.setUserPermission(
        user.permission?.enabled ? user.permission?.modules : null
      );
      this.filterMenuModules();
      this._socketIOService.connect();
    });
  };

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }
}
